import React, { useState } from 'react'
import GoogleMapReact from 'google-map-react'
import {
  makeStyles,
  createStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from '@material-ui/core/'
import CloseIcon from '@material-ui/icons/Close'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    mapIcon: {
      padding: 0,
    },
    mapWrapper: {
      height: '80vh',
      padding: theme.spacing(0),
    },
    closeButton: {
      color: '#111827',
    },
    dialogTitle: {
      backgroundColor: '#ffff',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      color: '#111827',
    },
  }),
)
// const AnyReactComponent = ({ text }) => <span>{text}</span>
const GoogleMap = (props) => {
  const classes = useStyles()
  const { i18n } = useTranslation()
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const [open, setOpen] = useState(false)
  const handleClose = (params) => {
    setOpen(false)
  }
  const handleOpen = (e) => {
    e.stopPropagation()
    setOpen(true)
  }

  const defaultProps = {
    center: {
      lat: Number(props.lat),
      lng: Number(props.lng),
    },
    defaultCenter: {
      lat: 22.3193,
      lng: 114.1694,
    },
    zoom: 15,
  }

  return (
    <>
      <Box display="inline-block" flexShrink={0} onClick={handleOpen}>
        {props.children}
      </Box>
      <Dialog
        fullScreen={isMobile}
        maxWidth="lg"
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="Google Map Dialog"
      >
        <DialogTitle disableTypography className={classes.dialogTitle} id="google-map-dialog-title">
          <Typography
            variant="h5"
            color="initial"
            component="div"
            style={{ fontWeight: 800, fontSize: isMobile ? 18 : 20 }}
          >
            {props.name}
            <Box fontSize="16px" fontWeight={400}>
              {props.address}
            </Box>
          </Typography>
          <IconButton
            className={classes.closeButton}
            aria-label="close"
            onClick={handleClose}
            color="primary"
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.mapWrapper}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
              language: i18n.language,
              libraries: ['places'],
            }}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
            debounced
            // MapId for styling google map
            options={{
              mapId: process.env.REACT_APP_MAP_ID,
              streetViewControl: true,
            }}
            onGoogleApiLoaded={({ map, maps }) => {
              // Use google default marker style

              const marker = new maps.Marker({
                position: defaultProps.center,
                map: map,
              })

              return marker
            }}
          >
            {/* <AnyReactComponent lat={props.lat} lng={props.lng} text={props.name} /> */}
          </GoogleMapReact>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default GoogleMap
